import VerticalSecond from './view';

export default VerticalSecond;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/verticalSecond/index.js